<div class="corepages">

    <mat-card class="filter">
     <div class="orgcount">
      <div class="back">
        <button mat-icon-button [routerLink]="'/esignature'" ><mat-icon>keyboard_arrow_left</mat-icon></button>
       </div>
       <div class="all">
        Verification Form
       </div>
     </div>
  
  
     <div class="search">
       <mat-form-field appearance="fill">
         <mat-label>Search items in core </mat-label>
         <input matInput type="text"   maxlength="30">
         <button color="basic"  matSuffix mat-icon-button aria-label="Clear">
           <mat-icon>search</mat-icon>
         </button>
       </mat-form-field>
     </div>
  
  
     <button mat-icon-button  matTooltipClass="tooltip"
       matTooltip="Customize Coloumn">
       <mat-icon>view_column</mat-icon>
     </button>
  
     <button mat-icon-button  matTooltipClass="tooltip" matTooltip="Filters">
       <mat-icon>filter_list</mat-icon>
     </button>
  
     
  
   </mat-card>

   <div class="zui-wrapper">
    <div class="zui-scroller">
        <p class="temp" >All forms fields will appear here same as core listing</p>
    </div>
    </div>
  
  
  </div>



 